"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

var _icon = _interopRequireDefault(require("../icon"));

var _index = _interopRequireDefault(require("./index.scss"));

var CollapsibleNavigation = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(CollapsibleNavigation, _Component);

  function CollapsibleNavigation(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CollapsibleNavigation);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(CollapsibleNavigation).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleToggle", function () {
      return _this.setState({
        isExpanded: !_this.state.isExpanded
      });
    });
    _this.state = {
      isExpanded: false
    };
    return _this;
  }

  (0, _createClass2["default"])(CollapsibleNavigation, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var isExpanded = this.state.isExpanded;
      var _this$props = this.props,
          title = _this$props.title,
          items = _this$props.items,
          classnames = _this$props.classnames;
      var expandedIcon = this.props.expandedIcon || 'chevron-up';
      var collapsedIcon = this.props.collapsedIcon || 'chevron-down';
      return _react["default"].createElement("nav", {
        className: (0, _classnames["default"])(_index["default"].CollapsibleNavigation, classnames.wrapper)
      }, _react["default"].createElement("div", {
        className: _index["default"].heading
      }, _react["default"].createElement("button", {
        "aria-hidden": "true",
        className: _index["default"].toggleItems,
        onClick: this.handleToggle
      }, _react["default"].createElement(_icon["default"], {
        type: isExpanded ? expandedIcon : collapsedIcon,
        size: "medium"
      })), title), _react["default"].createElement("ul", {
        className: (0, _classnames["default"])(_index["default"].items, classnames.items, (0, _defineProperty2["default"])({}, _index["default"].isExpanded, isExpanded))
      }, items.map(function (item, i) {
        return _react["default"].createElement("li", {
          key: "item".concat(i),
          className: (0, _classnames["default"])(_index["default"].item, classnames.item),
          onClick: _this2.handleToggle
        }, item);
      })));
    }
  }]);
  return CollapsibleNavigation;
}(_react.Component);

CollapsibleNavigation.defaultProps = {
  classnames: {}
};
CollapsibleNavigation.propTypes = {
  title: _propTypes.element,
  items: (0, _propTypes.arrayOf)(_propTypes.element).isRequired,
  expandedIcon: _propTypes.string,
  collapsedIcon: _propTypes.string,
  classnames: (0, _propTypes.shape)({
    wrapper: _propTypes.string,
    items: _propTypes.string,
    item: _propTypes.string
  })
};
var _default = CollapsibleNavigation;
exports["default"] = _default;